
const faqVisibilityToggle = () => {

    const faqItems = document.querySelectorAll(".i-faq");

    faqItems.forEach(item => {

        item.addEventListener("click", (e) => {
            let element = e.target as HTMLElement
            if (element.classList.contains("toggle") || element.classList.contains("i-faq__heading")) {
                item.classList.toggle("--js-closed")
                item.querySelector(".toggle").classList.toggle("--js-closed")
            }
        })
    });
}


const faqClose = () => {
    const faqItems = document.querySelectorAll(".i-faq");
    faqItems.forEach(item => {
        const toggle = item.querySelector(".toggle");
        toggle.classList.add("--js-closed")
        item.classList.add("--js-closed")
    });
}

faqClose();
faqVisibilityToggle();
